import { gql } from "@apollo/client"

export const QUERY_AUTOMATCHING_STATS = gql`
    query automatchingStats($shopId: Long, $periodDays: Int) {
        automatchingStats(shopId: $shopId, periodDays: $periodDays) {
            openCount
            openCountTotal
            approvedCount
            averageOpenScore
            shopStats {
                shopId
                name
                lang
                openCount
                approvedInPeriod
            }
            dailyActivity {
                date
                createdCount
                approvedCount
            }
            scoreBuckets {
                label
                count
            }
            matchSourceSplit {
                kiCount
                algorithmCount
            }
            topProducers {
                id
                name
                count
            }
        }
        shops {
            id
            colorHex
        }
    }
`

export const QUERY_AUTOMATCHING_SHOPS = gql`
    query automatchingShops {
        automatchingShops {
            id
            name
            lang
            remainingMatches
        }
    }
`

export const QUERY_AUTOMATCHING_PRODUCERS = gql`
    query automatchingProducers($filter: AutomatchingFilterInput!) {
        automatchingProducers(filter: $filter) {
            id
            name
            count
        }
    }
`

export const QUERY_AUTOMATCHING_MATCH_TYPES = gql`
    query automatchingMatchTypes($filter: AutomatchingFilterInput!) {
        automatchingMatchTypes(filter: $filter) {
            matchType
            label
            count
        }
    }
`

export const QUERY_AUTOMATCHING_QUEUE = gql`
    query automatchingQueue($filter: AutomatchingFilterInput!, $offset: Int!, $limit: Int!) {
        automatchingQueue(filter: $filter, offset: $offset, limit: $limit) {
            totalCount
        }
    }
`

export const QUERY_AUTOMATCHING_APPROVAL_AT_POSITION = gql`
    query automatchingApprovalAtPosition($filter: AutomatchingFilterInput!, $position: Int!) {
        automatchingApprovalAtPosition(filter: $filter, position: $position) {
            status
            requestedPosition
            actualPosition
            skippedCount
            totalCount
            approval {
                shopId
                direction
                containsUnreviewedItems
                master {
                    matchId
                    productNr
                    customerProductNr
                    name
                    producer
                    modelName
                    color
                    extArtnr
                    price
                    stock
                    imageUrl
                    productUrl
                    score
                }
                candidates {
                    matchId
                    shopId
                    productNr
                    customerProductNr
                    name
                    producer
                    modelName
                    color
                    extArtnr
                    price
                    stock
                    imageUrl
                    productUrl
                    score
                    approved
                    rejected
                    otherApprovedMatch
                    matchingDetailsJson
                    aiMatchingDetailsJson
                    matchingInfo
                }
            }
        }
    }
`

export const MUTATION_APPROVE = gql`
    mutation approveAutomatchingMatch($matchId: Long!, $direction: AutomatchingDirection!) {
        approveAutomatchingMatch(matchId: $matchId, direction: $direction) {
            success
            mappingUpdated
            instantCrawlStarted
            warnings
        }
    }
`

export const MUTATION_REJECT_ALL = gql`
    mutation rejectAllAutomatchingMatches(
        $direction: AutomatchingDirection!
        $shopId: Long!
        $masterProductNr: String!
    ) {
        rejectAllAutomatchingMatches(
            direction: $direction
            shopId: $shopId
            masterProductNr: $masterProductNr
        ) {
            success
            rejectedCount
        }
    }
`

export const MUTATION_BULK_APPROVE = gql`
    mutation bulkApproveAutomatchingMatches($filter: AutomatchingFilterInput!, $minScore: Int!) {
        bulkApproveAutomatchingMatches(filter: $filter, minScore: $minScore) {
            success
            approvedCount
            skippedCount
        }
    }
`
